import axios from "axios";
import {env} from "../configs/environment.config";

export const fetch = (method, url, body, conf) => {
    const token = localStorage.getItem('token');
    const baseUrl = url.startsWith('/v1') ? env.API_BASE_URL : '';
    axios.defaults.headers.common['Authorization'] = `${token}`;
    return new Promise((resolve, reject) => {
        axios[method.toLowerCase()](baseUrl + url, method === "GET" ? conf : body, conf)
            .then(result => {
                resolve(result);
            })
            .catch(error => {
                reject(error);
            })
    })
}